import type {
  ColumnDef,
  ColumnFiltersState,
  OnChangeFn,
  SortingState,
  VisibilityState
} from '@tanstack/react-table';
import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table';

import type { CatalogItem } from '@/entities/catalog-item';
import { arrEqualsAll } from '../lib/filters';

const defaultColumn = {
  filterFn: arrEqualsAll
};

interface CatalogTableInstanceOptions {
  data: CatalogItem[];
  columns: ColumnDef<CatalogItem>[];
  columnVisibility: VisibilityState;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  onColumnVisibilityChange: OnChangeFn<VisibilityState>;
  onSortingChange: OnChangeFn<SortingState>;
}

export function useCatalogTableInstance({
  data,
  columns,
  columnVisibility,
  sorting,
  columnFilters,
  onColumnVisibilityChange,
  onSortingChange
}: CatalogTableInstanceOptions) {
  return useReactTable({
    data,
    columns,
    defaultColumn,
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getCoreRowModel: getCoreRowModel(),
    state: {
      columnVisibility,
      sorting,
      columnFilters
    },
    onColumnVisibilityChange,
    onSortingChange
  });
}
